export enum AcronymIconText {
  LeadULI = 'Lead ULI',
}
